import { createApp } from 'vue'
import App from './App.vue'
import 'ant-design-vue/dist/reset.css'
import './styles/terminal.css'

createApp(App).mount('#app')
